<template>
  <div class="grid grid-cols-3 grid-rows-3 gap-[20%]">
    <template
      v-for="i in 9"
      :key="i"
    >
      <svg
        :id="`sq${i}`"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          :width="12"
          :height="12"
          fill="currentColor"
        />
      </svg>
    </template>
  </div>
</template>

<style scoped>
@keyframes opacityChange {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

#sq1 {
  animation: opacityChange 675ms ease-in-out 0s infinite alternate;
}

#sq2 {
  animation: opacityChange 675ms ease-in-out 75ms infinite alternate;
}

#sq3 {
  animation: opacityChange 675ms ease-in-out 150ms infinite;
}

#sq4 {
  animation: opacityChange 675ms ease-in-out 225ms infinite;
}

#sq5 {
  animation: opacityChange 675ms ease-in-out 300ms infinite;
}

#sq6 {
  animation: opacityChange 675ms ease-in-out 375ms infinite;
}

#sq7 {
  animation: opacityChange 675ms ease-in-out 450ms infinite;
}

#sq8 {
  animation: opacityChange 675ms ease-in-out 525ms infinite;
}

#sq9 {
  animation: opacityChange 675ms ease-in-out 600ms infinite;
}
</style>
